import { Link } from '@codex/basics';
import { paths, replacePlaceholders, translations } from '@dc/ui-library';
import React, { Fragment } from 'react';
import dayjs from 'dayjs';

import { links } from './contants';

function mapLinks(order, link) {
  const orderDetailUrl = `${paths.MY_ACCOUNT_PATH}#order-detail/${order.orderReference}`;

  switch (link.id) {
    case 'tracking': {
      const hasTracking = !!order.singleOrders[0].products[0].trackings;
      const trackingUrl = hasTracking &&
        order.singleOrders[0].products[0].trackings[0].trackingLink;
      return {
        ...link,
        url: trackingUrl || orderDetailUrl,
        display: hasTracking
      };
    }
    case 'protection':
      return {
        ...link,
        url: orderDetailUrl
      };
    default:
      return link;
  }
}

function countProducts(order) {
  return order.singleOrders.reduce(
    (total, singleOrder) => total + singleOrder.products.length,
    0
  );
}

export function mapOrders(order) {
  return {
    ...order,
    productsCount: countProducts(order),
    links: links
      .map((link) => mapLinks(order, link))
      .filter((link) => link.display !== false)
  };
}

export function getDaysSinceOrdered(rawOrderDate) {
  const pattern = /(\d{1,2})(\w+)\s(\w+)\s(\d{4})/;

  const orderDate = dayjs(rawOrderDate.replace(pattern, '$4-$3-$1'));
  return dayjs().diff(orderDate, 'day');
}

export function mapOrdersForAnalytics(order) {
  return {
    orderNumber: order.orderReference,
    daysSinceOrdered: getDaysSinceOrdered(order.orderDate),
    orderStatus: translations[order.singleOrders[0].officialOrderStatus.tag],
    itemsInOrder: order.singleOrders.reduce(
      (acc, singleOrder) => acc + singleOrder.products.length,
      0
    )
  };
}

export function mapWishlistForAnalytics(item) {
  return {
    productID: item.productId,
    priceDrop: item.rawPrice < item.rawPriceWhenSaved,
    starRating: item.rating,
    numberOfReviews: item.ratingCount
  };
}

export function getTitle(translation, name, count, link, dataInteraction) {
  return (
    <>
      {replacePlaceholders(
        translation,
        {
          '[NAME]': name,
          '[S]': count > 1 ? 's' : ''
        }
      )}
      {link && (
        <>
          {' '}
          <Link href={link} data-interaction={dataInteraction}>
            {replacePlaceholders(translations.view_all_link, { '[COUNT]': count })}
          </Link>
        </>
      )}
    </>
  );
}
